import React from 'react';
import { Link } from 'react-router-dom';
import { openCookieSettings } from '../lib/consent';

const SHOW_PENDING = /(\.preview\.emergentagent\.com|localhost)$/.test(window.location.hostname);

const Pending = ({ children }) => SHOW_PENDING && (
  <span
    data-testid="legal-pending"
    className="ml-2 inline-block bg-[#f3e2b8] px-2 py-0.5 text-[11px] uppercase tracking-[0.12em] text-ink/80 align-middle"
  >
    Afventer godkendelse: {children}
  </span>
);

const Section = ({ s }) => (
  <section className="py-10 border-t border-ink/10">
    <h2 className="font-serif font-light text-2xl md:text-3xl">{s.h}</h2>
    {s.p?.map((t) => (
      <p key={t} className="mt-5 text-base font-light leading-relaxed text-ink/80">{t}</p>
    ))}
    {s.list && (
      <ul className="mt-5 space-y-3 list-disc pl-5 text-base font-light leading-relaxed text-ink/80">
        {s.list.map((i) => (
          <li key={i.t}>
            {i.t}
            {i.pending && <Pending>{i.pending}</Pending>}
          </li>
        ))}
      </ul>
    )}
    {s.table && (
      <div className="mt-6 overflow-x-auto">
        <table className="w-full text-sm font-light text-left">
          <thead className="text-[11px] uppercase tracking-[0.15em] text-stone">
            <tr>{['Navn', 'Udbyder', 'Formål', 'Varighed', 'Type'].map((h) => <th key={h} className="py-3 pr-6 font-normal">{h}</th>)}</tr>
          </thead>
          <tbody>
            {s.table.map((r) => (
              <tr key={r[0]} className="border-t border-ink/10">
                {r.map((c, i) => <td key={i} className="py-3 pr-6 text-ink/80">{c}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
    {s.after?.map((t) => (
      <p key={t} className="mt-5 text-base font-light leading-relaxed text-ink/80">{t}</p>
    ))}
    {s.pendingNote && SHOW_PENDING && <p className="mt-5"><Pending>{s.pendingNote}</Pending></p>}
    {s.settingsButton && (
      <button
        data-testid="legal-cookie-settings-btn"
        onClick={openCookieSettings}
        className="mt-6 bg-ink text-bone px-8 py-3 text-[11px] uppercase tracking-[0.22em] hover:bg-ink/85 transition-colors"
      >
        Skift cookieindstillinger
      </button>
    )}
  </section>
);

const LegalPage = ({ data }) => (
  <div data-testid={`legal-page-${data.slug}`} className="bg-bone pt-36 md:pt-44 pb-24">
    <div className="mx-auto max-w-[900px] px-6 md:px-12">
      <p className="text-[11px] uppercase tracking-[0.3em] text-stone">{data.eyebrow}</p>
      <h1 className="mt-5 font-serif font-light text-4xl sm:text-5xl lg:text-6xl">{data.title}</h1>
      <p className="mt-6 mb-12 text-sm font-light text-stone">Senest opdateret: {data.updated}</p>
      {data.sections.map((s) => <Section key={s.h} s={s} />)}
      <div className="pt-10 border-t border-ink/10 flex gap-8 text-[11px] uppercase tracking-[0.2em]">
        <Link to="/privatlivspolitik" className="link-underline">Privatlivspolitik</Link>
        <Link to="/cookiepolitik" className="link-underline">Cookiepolitik</Link>
      </div>
    </div>
  </div>
);

export default LegalPage;
